<template>
  <div>
    <BaseModal
      :showing="visible"
      size="max-w-5xl"
      @opened="onOpened"
      @close="$emit('close')"
    >
      <div class="space-y-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div>
              <h3 class="text-lg font-bold leading-6 text-gray-900">
                Daftar Faktur
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Daftar faktur penjualan dan pembelian
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-4 border-t border-gray-200 pt-6">
          <div class="flex justify-end gap-x-2">
            <BaseInput
              placeholder="Cari Kode"
              type="search"
              :shadow="false"
              debounce
              v-model="filter.search"
              @native-input="loadOrders"
            />
          </div>
          <datatable
            :columns="tableColumns"
            :scroll-x="false"
            :total="orders.meta.page.total"
            :perPage="orders.meta.page.perPage"
            :currentPage="orders.meta.page.currentPage"
            @pagechanged="onPagechanged"
          >
            <template v-slot:tbody="{ classes }">
              <tr
                v-for="order in orders.data"
                :key="order.id"
                :class="[
                  classes.tr,
                  'cursor-pointer bg-white hover:bg-green-100',
                ]"
                @click="onClickOrder(order)"
              >
                <td :class="[classes.td]">
                  <OrderCodeLabel :order="order" />
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>
    </BaseModal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal';
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';
import OrderCodeLabel from './order-code-label.vue';

export default {
  components: {
    BaseModal,
    OrderCodeLabel,
  },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    requestParams: null,
    columns: {
      type: Array,
      default: () => ['code'],
    },
  },
  emits: ['close', 'click-order'],
  data() {
    return {
      orders: {
        data: [],
        meta: {
          page: {},
        },
      },
      loading: false,
      filter: {
        search: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    tableColumns() {
      return [
        {
          id: 'code',
          name: 'Kode Faktur',
        },
      ].filter((item) => !!item);
    },
  },
  methods: {
    async loadOrders(params) {
      this.loading = true;

      const orderFields = ['order_id', 'origin_code', 'destination_code'].join(
        ','
      );

      const [res, error] = await this.request(`/api/v1/orders`, {
        params: {
          ...this.requestParams,
          'page[size]': 5,
          'fields[simple-orders]': orderFields,
          'filter[search]': this.filter.search,
          ...params,
        },
      });

      if (!error) {
        this.orders = res;
      }

      this.loading = false;
    },
    onClickOrder(order) {
      this.$emit('click-order', order);
    },
    onOpened() {
      this.filter.search = null;

      this.loadOrders();
    },
    onPagechanged(page) {
      this.loadOrders({
        'page[number]': page,
      });
    },
  },
};
</script>
